/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const dataRemovalRequestListDataSchema = z.object({
	data: z.array(
		z.object({
			id: z.string(),
			candidateId: z.string(),
			organisationId: z.string(),
			status: z.union([
				z.literal('pending'),
				z.literal('notified'),
				z.literal('approved'),
				z.literal('rejected'),
				z.literal('completed'),
				z.literal('expired'),
			]),
			decisionSource: z.union([z.literal('manual'), z.literal('auto')]),
			requestedAt: z.string(),
			notifiedAt: z.string().nullable(),
			decidedAt: z.string().nullable(),
			decidedByUserId: z.string().nullable(),
			rejectionReason: z.string().nullable(),
			completedAt: z.string().nullable(),
		}),
	),
})

export type DataRemovalRequestListDataSchema = z.infer<typeof dataRemovalRequestListDataSchema>
